import * as React from "react";
import ChatEmojiComponent from "./chatEmojiComponent";
import heartIcon from "public@assets/images/heart-icon.png";
import emojiIcon from "public@assets/images/emoji-icon.png";
import noticeIcon from "public@assets/images/notice-icon.png";
import canvasHeart from "public@assets/js/canvas-heart-init";
import { handelrHMS } from "public@tool/handler";
import { stringToDom } from "./handleEmoji";
import * as cn from "classnames";
import { observer, inject } from "mobx-react";

import { action } from "pc@action/index";

interface IProps {
  store?: any;
}

interface IState {
  isEmoji: boolean;
}

@inject("store")
@observer
export default class InteractiveChatRoom extends React.Component<IProps, IState> {
  private textInput: any;
  constructor(props: IProps) {
    super(props);
    this.state = {
      isEmoji: false
    };
  }

  public componentDidMount() {
    canvasHeart();
  }

  public onMessageEmoji = (emoji: string) => {
    action.onMessageEmoji(emoji);
    this.textInput.focus();
  };

  public votePopup = (e: any) => {
    action.getConfirmVote(e.target.dataset.voteid);
  };

  public onMessageInput = (e: any) => {
    action.onMessageInput(e.target.value);
  };

  public onMessageKeyDown = (e: any) => {
    if (e.keyCode === 13) {
      action.onMessageSend();
    }
  };

  public switcherEmoji = () => {
    this.setState({
      isEmoji: !this.state.isEmoji
    });
  };

  public inputFocus = () => {
    this.setState({
      isEmoji: false
    });
  };

  public render() {
    const { cloudMessage, messageValue, interactiveType } = this.props.store;

    const { isEmoji } = this.state;

    return (
      <div
        className={cn("interactive__chat--room", {
          interactive__active: interactiveType === "mobile"
        })}
      >
        <div className="live__lean--cloud">
          {cloudMessage.map((e: any, i: number) => {
            let params = {};
            let spanParams = {};
            const msgTime = handelrHMS(e.timestamp);
            if (e.attributes && e.attributes.presenter) {
              params = {
                className: "chat__tourist chat__owner "
              };
              if (e.attributes && e.attributes.notice) {
                spanParams = {
                  className: "chat__color--red"
                };
              } else {
                spanParams = {
                  className: "chat__content--compere chat__color--green"
                };
              }
            } else {
              params = {
                "data-clientid": e.from,
                "data-timestamp": e.timestamp,
                "data-msgid": e.id,
                className: "chat__tourist"
              };
              spanParams = {
                className: "chat__color--blue"
              };
            }
            const txt: any = stringToDom(e.text);
            return e.text === undefined ? (
              ""
            ) : (
              <div className="chat__content" key={i}>
                {e.attributes.notice ? (
                  <div className="notice__strip">
                    <div className="notice__container">
                      <img src={noticeIcon} alt="" />
                      <span>公告:</span>
                    </div>
                    <p dangerouslySetInnerHTML={{ __html: txt }} />
                  </div>
                ) : (
                  <h3 {...params}>
                    <span {...spanParams} style={{ marginRight: "10px" }}>
                      {e.from.trim()}
                    </span>
                    {msgTime}
                  </h3>
                )}

                {e.attributes && e.attributes.vote ? (
                  <ChatRoomVote
                    voteId={e.attributes.vote.voteId}
                    voteTitle={e.attributes.vote.voteTitle}
                    voteState={e.attributes.vote.voteState}
                    votePopup={this.votePopup}
                  />
                ) : (
                  !e.attributes.notice && <p dangerouslySetInnerHTML={{ __html: txt }} />
                )}
              </div>
            );
          })}
        </div>

        <div className="interactive__chat--input-chat">
          <div className="interactive__chat--container">
            <div className="chat__extend--column">
              <div className="chat__extend--emoji" onClick={this.switcherEmoji}>
                <img src={emojiIcon} alt="" />
              </div>

              <div className="chat__extend--heart">
                <div id="heart__canvas" onClick={action.onAddPraiseCount}>
                  <img src={heartIcon} alt="" />
                </div>
              </div>

              {isEmoji && (
                <div className="chat__manage--emoji">
                  <ChatEmojiComponent onMessageEmoji={this.onMessageEmoji} />
                </div>
              )}
            </div>

            <div className="interactive__chat--input-box">
              <input
                ref={input => {
                  this.textInput = input;
                }}
                onFocus={this.inputFocus}
                id="interactive__input"
                type="text"
                value={messageValue}
                onChange={this.onMessageInput}
                onKeyDown={this.onMessageKeyDown}
              />
              <button onClick={action.onMessageSend}>发送</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const ChatRoomVote = (option: {
  voteId: string;
  voteTitle: string;
  voteState: string;
  votePopup: (e: any) => void;
}) => {
  const { voteId, voteTitle, voteState, votePopup } = option;
  return (
    <div className="question__item" data-voteid={voteId} onClick={votePopup}>
      <div className="question__vote--info" style={{ pointerEvents: "none" }}>
        <div className="question__picture">
          <img src="//devcdn.xylink.com/live/mgr/img/vote/icon-vote.png" alt="" />
        </div>
        <span className="question__title">{voteTitle}</span>
      </div>

      <div className="question__status">
        {voteState === "EXPIRED" ? (
          <div className="question__status-other">
            {/*{language.voteFinish}*/}
            主持人
          </div>
        ) : (
          <div className="question__status-other">
            {/*{language.voteModerator}*/}
            主持人发起了投票
          </div>
        )
        // <div className="question__status-normal">主持人发起投票</div>
        }
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pc/component/sidebar/component/InteractiveChatRoom/index.tsx